// Module
var code = "<br>Orders: :numberOrders <br>SKUs: :numberSKUs <br>CreatedAt: :createdAtMin to :createdAtMax <br>Settled Orders: :numberSettled <br>NOT Settled Orders: :numberNotSettled <br>SettledAt: :settledAtMin to :settledAtMax <br>shipCountries: :shipCountries <div class=\"button is-small\" id=\"viewOrdersData\">View data</div> ";
// Exports
export default code;